import React, { useMemo } from 'react';
import { Progress } from 'antd';
import classNames from 'classnames';
import { getString } from '@nackle/intl-tools';
import { HourglassOutlined, CheckCircleOutlined } from '@ant-design/icons';
import './styles.less';
import { PaperIcon } from '@nackle/paper';

const classBase = 'info-banner';
export const InfoBanner = ( { className, title, isLoading, locked, 
    percentComplete, type, imageSrc, backgroundSrc, hidePercentage = false, additionalClass = '' } ) => {

    const inProgress = useMemo( () => {
        if ( percentComplete > 0 && percentComplete < 100 ) {
            return true;
        } else {
            return false;
        }
    }, [ percentComplete ] );

    const isComplete = useMemo( () => {
        if ( percentComplete == 100 ) {
            return true;
        } else {
            return false;
        }
    }, [ percentComplete ] );


    return (
        <div className={ classNames( classBase, className, additionalClass, type ) } style={ { backgroundImage: backgroundSrc && `url('${ backgroundSrc }')` } } >
            <div 
                className={ `${ classBase }-content` }
            >
                <h1 className='title'>
                    { title }
                </h1>
                    
                { !isLoading && !isNaN( percentComplete ) && !hidePercentage &&
                    <div className='progress'>
                    { `${ Math.trunc( percentComplete ) }%` }
                
                        <Progress
                            size="small"
                            showInfo={ false } 
                            percent={ percentComplete }
                        />
                    </div>
                }

                { hidePercentage && (
                    locked ?
                    <div className="progress-text">
                        <PaperIcon collection='ultimate' icon='Lock4' />
                        <span>{ getString( 'learningObject.actions.locked' ) }</span>
                    </div> :
                    inProgress ?
                    <div className="progress-text">
                        <HourglassOutlined/>
                        <span>{ getString( 'progress.missions.inProgress' ) }</span>
                    </div> :
                    isComplete ?
                    <div className="progress-text">
                        <CheckCircleOutlined className='completed' />
                        <span>{ getString( 'progress.missions.complete' ) }</span>
                    </div> : <></> )
                }

            </div> 

            <div 
                className='header-image'
            >
                { imageSrc && !isLoading && <img src={ imageSrc }/> }
            </div> 
        </div>
    );
};